export enum ETAPAS_PROJETO {
    SLA_ENGENHARIA = "sla_engenharia",
    PRE_ORCAMENTO = "pre_orcamento",
    PROPOSTA_FINAL = "proposta_final",
    AGUARDANDO_PAGAMENTO = "aguardando_pagamento",
    PAGAMENTO_APROVADO = "pagamento_aprovado",
    NEGOCIACAO = "negociacao",
    AGUARDANDO_FATURAMENTO = "aguardando_faturamento",
    FATURADO = "faturado",
    EM_TRANSITO = "em_transito",
    ENTREGUE = "entregue",
    FINALIZADO = "finalizado",
    CANCELADO = "cancelado",
    EXPIRADO = "expirado",
    VISITADO = "visitado",
}

export enum TIPO_PROJETO {
    VERTICAL = "vertical",
    PERSONALIZADO = "personalizado",
    DIMENSIONADO = "dimensionado",
    AVULSO = "avulso",
    KIT = "kit",
    MISTO = "misto", // (kit + avulso)
}

export enum SEGMENTO_PROJETO {
    DISTRIBUICAO_ONGRID = "distribuicao_ongrid",
    DISTRIBUICAO_OFFGRID = "distribuicao_offgrid",
    VERTICAL_ONGRID = "vertical_ongrid",
    VERTICAL_OFFGRID = "vertical_offgrid",
}

export enum UNIDADE_TEMPO {
    ANOS = "anos",
    MESES = "meses"
}

export enum SITUACAO_PEDIDO {
    PENDENTE = "pendente",
    FINALIZADO = "finalizado",
    CANCELADO = "cancelado",
}

export enum ETAPAS_PEDIDO {
    ENVIO_PAGAMENTO = "envio_pagamento",
    AGUARDANDO_PAGAMENTO = "aguardando_pagamento",
    NEGOCIACAO = "negociacao",
    PAGAMENTO_APROVADO = "pagamento_aprovado",
    GESTAO_PEDIDOS = "gestao_pedidos",
    AGUARDANDO_FATURAMENTO = "aguardando_faturamento",
    FATURADO = "faturado",
    EM_TRANSITO = "em_transito",
    ENTREGUE = "entregue",
}

export const LISTA_ETAPA_VENDA = [
    {
        text: "SLA Engenharia",
        value: "sla_engenharia",
    },
    {
        text: "Pré-Orçamento",
        value: "pre_orcamento",
    },
    {
        text: "Proposta Final",
        value: "proposta_final",
    },
    {
        text: "Aguardando Pagamento",
        value: "aguardando_pagamento",
    },
    {
        text: "Negociação",
        value: "negociacao",
    },
    {
        text: "Aguardando Faturamento",
        value: "aguardando_faturamento",
    },
    {
        text: "Faturado",
        value: "faturado",
    },
    {
        text: "Em transito",
        value: "em_transito",
    },
    {
        text: "Entregue",
        value: "entregue",
    }
];

export interface ChangeStatePedido {
    [key: string]: ChangeValidate;
    codigo_venda: ChangeValidate;
}
export interface ChangeState {
    [key: string]: ChangeValidate;
    codigo_venda: ChangeValidate;
    solucao_sugerida: ChangeValidate;
    componentes: ChangeValidate;
    titulo: ChangeValidate;
    distribuidor_id: ChangeValidate;
    revenda_id: ChangeValidate;
    status_projeto: ChangeValidate;
    status_projeto_pagamento: ChangeValidate;
    expirado: ChangeValidate;
    tipo_faturamento: ChangeValidate;
    tipo: ChangeValidate;
    cliente_proposta: ChangeValidate;
    cpf_cnpj_proposta: ChangeValidate;
    email_proposta: ChangeValidate;
    endereco_proposta: ChangeValidate;
    dados_concessionaria_payback: ChangeValidate;
    simultaneidade: ChangeValidate;
    estabelecimento: ChangeValidate;
    potencia: ChangeValidate;
    preco_kwh: ChangeValidate;
    tipo_proposta: ChangeValidate;
    percentual_comissao_distribuidor: ChangeValidate;
    valor_servico: ChangeValidate;
    valor_margem: ChangeValidate;
    valor_desconto: ChangeValidate;
    valor_servico_pis_cofins: ChangeValidate;
    valor_projeto: ChangeValidate;
    termos_aceite: ChangeValidate;
    codigo_servico: ChangeValidate;
}
  
interface ChangeValidate {
    hasChanged: boolean;
}

export const INITIAL_CHANGE_STATE: ChangeState = {
    codigo_venda: {
        hasChanged: false,
    },
    solucao_sugerida: {
        hasChanged: false,
    },
    componentes: {
        hasChanged: false,
    },
    titulo: {
        hasChanged: false,
    },
    distribuidor_id: {
        hasChanged: false,
    },
    revenda_id: {
        hasChanged: false,
    },
    status_projeto: {
        hasChanged: false,
    },
    status_projeto_pagamento: {
        hasChanged: false,
    },
    expirado: {
        hasChanged: false,
    },
    tipo_faturamento: {
        hasChanged: false,
    },
    tipo: {
        hasChanged: false,
    },
    cliente_proposta: {
        hasChanged: false,
    },
    cpf_cnpj_proposta: {
        hasChanged: false,
    },
    email_proposta: {
        hasChanged: false,
    },
    endereco_proposta: {
        hasChanged: false,
    },
    dados_concessionaria_payback: {
        hasChanged: false,
    },
    simultaneidade: {
        hasChanged: false,
    },
    estabelecimento: {
        hasChanged: false,
    },
    potencia: {
        hasChanged: false,
    },
    preco_kwh: {
        hasChanged: false,
    },
    tipo_proposta: {
        hasChanged: false,
    },
    percentual_comissao_distribuidor: {
        hasChanged: false,
    },
    valor_servico: {
        hasChanged: false,
    },
    valor_margem: {
        hasChanged: false,
    },
    valor_desconto: {
        hasChanged: false,
    },
    valor_servico_pis_cofins: {
        hasChanged: false,
    },
    valor_projeto: {
        hasChanged: false,
    },
    termos_aceite: {
        hasChanged: false,
    },
    codigo_servico: {
        hasChanged: false,
    }
};
export const INITIAL_CHANGE_STATE_PEDIDO: ChangeStatePedido = {
    codigo_venda: {
        hasChanged: false,
    }
};

export interface ChangeStateDesconto {
    [key: string]: ChangeValidate;
    valor_intelbras: ChangeValidate;
    justificativa: ChangeValidate;
    desconto_total: ChangeValidate;
    percentual_intelbras: ChangeValidate;
    percentual_revenda: ChangeValidate;
    percentual_distribuidor: ChangeValidate;
}

export const INITIAL_CHANGE_STATE_DESCONTO: ChangeStateDesconto = {
    valor_intelbras: {
        hasChanged: false,
    },
    justificativa: {
        hasChanged: false,
    },
    desconto_total: {
        hasChanged: false,
    },
    percentual_intelbras: {
        hasChanged: false,
    },
    percentual_revenda: {
        hasChanged: false,
    },
    percentual_distribuidor: {
        hasChanged: false,
    }
};

export interface ChangeStateNotaFiscal {
    [key: string]: ChangeValidate;
    valor: ChangeValidate;
    numero: ChangeValidate;
    peso_bruto: ChangeValidate;
    itens: ChangeValidate;
    estado: ChangeValidate;
    bairro: ChangeValidate;
    cidade: ChangeValidate;
    complemento: ChangeValidate;
    numero_endereco: ChangeValidate;
    logradouro: ChangeValidate;
    observacao: ChangeValidate;
}

export const INITIAL_CHANGE_STATE_NOTA: ChangeStateNotaFiscal = {
    valor: {
        hasChanged: false,
    },
    numero: {
        hasChanged: false,
    },
    peso_bruto: {
        hasChanged: false,
    },
    itens: {
        hasChanged: false,
    },
    estado: {
        hasChanged: false,
    },
    bairro: {
        hasChanged: false,
    },
    cidade: {
        hasChanged: false,
    },
    complemento: {
        hasChanged: false,
    },
    numero_endereco: {
        hasChanged: false,
    },
    logradouro: {
        hasChanged: false,
    },
    observacao: {
        hasChanged: false,
    }
};

export const FIELDS_PROJETO = [
    "solucao_sugerida",
    "componentes",
    "codigo_venda",
    "titulo",
    "distribuidor_id",
    "revenda_id",
    "status_projeto",
    "status_projeto_pagamento",
    "expirado",
    "tipo_faturamento",
    "tipo",
    "cliente_proposta",
    "cpf_cnpj_proposta",
    "email_proposta",
    "endereco",
    "dados_concessionaria_payback",
    "simultaneidade",
    "potencia",
    "preco_kwh",
    "tipo_proposta",
    "percentual_comissao_distribuidor",
    "valor_servico",
    "valor_margem",
    "valor_desconto",
    "valor_servico_pis_cofins",
    "valor_projeto",
    "termos_aceite",
    "aceitou_termos",
    "inversor_tensao",
    "inversor_tipo_conexao",
    "tipo_inversor",
    "termos_projeto",
    "previsao_faturamento",
    "fator_perdas",
    "potencia_desejada",
    "nome_modulo",
    "disposicao",
    "valor_produtos",
    "valor_produtos_desconto",
    "valor_total",
    "consumo",
    "revenda",
    "distribuidor",
    "tensao",
    "concessionaria",
    "estabelecimento",
    "valor_instalacao",
    "codigo_servico",
]

export const FIELDS_PEDIDOS = [
    "pedido_id",
    "pedido",
    "data_alteracao",
    "operacao",
    "usuario",
    "pedido_erp",
    "valor_total",
    "data_emissao",
    "nome_transportadora",
    "transportadora",
    "itens",
    "valor_produtos",
    "situacao",
    "situacao_avaliacao",
];

export const FIELDS_DESCONTOS = [
    "percentual_distribuidor",
    "percentual_revenda",
    "percentual_intelbras",
    "valor_intelbras",
    "justificativa",
    "desconto_total",
    "usuario"
];

export const FIELDS_NOTAS = [
    "valor",
    "numero",
    "peso_bruto",
    "itens",
    "estado",
    "bairro",
    "cidade",
    "complemento",
    "numero_endereco",
    "logradouro",
    "observacao",
    "created_at",
];

export const STATUS_PROJETO = [
    { text: "Pré-orçamento", value: "pre_orcamento" },
    { text: "Proposta Final", value: "proposta_final" },
    { text: "Proposta Final", value: "negociacao" },
    { text: "Proposta Final", value: "aguardando_pagamento" },
    { text: "Projeto Cancelado", value: "cancelado" },
    { text: "Pagamento Reconhecido", value: "pagamento_reconhecido" },
    { text: "Pagamento Reconhecido", value: "pagamento_aprovado" },
    { text: "Processando Informações do Pedido", value: "processando_informacoes_pedido" },
    { text: "Processando Informações do Pedido", value: "aguardando_faturamento" },
    { text: "Processando Informações do Pedido", value: "faturado" },
    { text: "Em Trânsito", value: "em_transito" },
    { text: "Produto Entregue", value: "entregue" },
    { text: "Projeto Finalizado", value: "finalizado" },
    { text: "Expirado", value: "expirado" },
    { text: "Visita Técnica Efetuada", value: "vistado" },
];